// Generic loading indicator — a bare spin ring by default, or a full-page
// centered variant (with an optional label) via `page`. `light` swaps in a
// white-on-translucent palette for use on a solid brand-colored button, where
// the default cyan ring would disappear against the cyan background.
export default function Spinner({ page, label, light }) {
  const cls = "spinner" + (light ? " spinner--light" : "");
  if (!page) return <span className={cls} />;
  return (
    <div className="page-loader">
      <span className={cls + " spinner--lg"} />
      {label && <span className="page-loader__label">{label}</span>}
    </div>
  );
}
